<ng-snotify></ng-snotify>

<app-login *ngIf="!isAuthed"></app-login>

<div *ngIf="isAuthed">

  <div class="nav-container">
    <div class="nav-logo-banner">
      <img src="assets/images/logo-alt.png" width="200" />
      <div>
        <a (click)="logout()">

          <div class="alt-text">
            Welcome {{firstname}} {{lastname}}
          </div>

          Logout
        </a>
      </div>

    </div>

    <nav>
      <ul>
        <!--<li>
      <a routerLink="/dashboard" routerLinkActive="active">
        Dashboard
      </a>
    </li>-->
        <!--<li>
      <a routerLink="/reports/rote" routerLinkActive="active"> Reports</a>
    </li>-->
        <li>
          <div class="dropdown">
            <div class="dropbtn nav-item dropdown">Reports</div>
            <div class="dropdown-content">
              <a routerLink="/reports/asset-register" routerLinkActive="active"> Asset Register</a>
              <a routerLink="/reports/rote" routerLinkActive="active"> Reports</a>
              <a routerLink="/reports/job-reports" routerLinkActive="active"> Job Report</a>
            </div>
          </div>
        </li>

        <li *ngIf="userProfileId == 1">
          <div class="dropdown">
            <div class="dropbtn nav-item dropdown">Administration</div>
            <div class="dropdown-content">
              <a routerLink="/admin/assets" routerLinkActive="active"> Equipment Management</a>
              <a routerLink="/admin/jobs" routerLinkActive="active"> Job Management</a>

            </div>
          </div>
        </li>

        <li *ngIf="userProfileId == 1">
          <div class="dropdown">
            <div class="dropbtn nav-item dropdown">Users</div>
            <div class="dropdown-content">
              <a routerLink="/users" routerLinkActive="active">Web Users</a>
              <a routerLink="/engineers" routerLinkActive="active"> Technicians</a>

            </div>
          </div>
        </li>
      </ul>
      <div style="padding:0.5%">
        <img src="assets/images/poweredbycoretransparentOrange.png" width="150" />
      </div>
    </nav>

  </div>
    <router-outlet></router-outlet>
  </div>


